import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getPaymentLimitHistory } from 'services/PaymentLimitsService'

export const useGetPaymentLimitHistory = (limitId: string | undefined) => {
  const id = limitId ?? ''

  return useQuery({
    queryKey: reactQueryKeys.paymentLimitHistory(id),
    queryFn: () => getPaymentLimitHistory(id),
    enabled: !!limitId,
  })
}
